import ITestControllerInitializationStrategy from './ITestControllerInitializationStrategy';
import SessionController from '../session/SessionController';
import TestController from '../TestController';
import FormController from '../form/FormController';
import TestModelBuilder from '../../builder/TestModelBuilder';
import NavigationController from '../navigation/NavigationController';
import TestConverter from '../../builder/TestConverter';
import StateController from '../state/StateController';
import DeliveryOptionBuilder from '../../builder/delivery-option/DeliveryOptionBuilder';
import ResponseController from '../response/ResponseController';
import Utility from '@/util/Utility';
import PersistenceManager from '../persistence/PersistenceManager';

class RegularTestControllerInitializationStrategy implements ITestControllerInitializationStrategy {
  initialize(qtiSessionId: string, sessionId: string, formId: string, testController: TestController): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      testController.sessionController = new SessionController(qtiSessionId, sessionId, testController);
      testController.responseController = new ResponseController(testController);
      testController.stateController = new StateController();

      testController.persistenceManager = new PersistenceManager();
      testController.persistenceManager.addPersistenceCommandCreator(testController.sessionController);
      testController.persistenceManager.addPersistenceCommandCreator(testController.responseController);

      testController.sessionController
        .initialize()
        .then(() => {
          if (testController!.sessionController!.sessionData!.qti_form_id !== formId) {
            reject(new Error('Unexpected form id value'));
          }
          testController.formController = new FormController(
            testController!.sessionController!.sessionData!.qti_form_id,
            testController!.baseServiceUrl
          );
          testController.formController
            .initialize()
            .then(() => {
              testController.test = new TestModelBuilder(testController.baseServiceUrl).build(
                testController.formController!.formData.get('qti')! as string,
                Utility.convertToArrayOfMaps(testController.formController!.formData.get('qti_items')! as Array<never>)
              );

              new DeliveryOptionBuilder().build(testController);

              testController.sessionController!.updateTestFromSessionData();

              testController!
                .responseController!.populateTestItems()
                .then(() => {
                  testController.navigationController = new NavigationController(
                    TestConverter.convertTest(testController.test!),
                    testController
                  );

                  resolve();
                })
                .catch((error) => {
                  reject(error);
                });
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });
  }
}

export default RegularTestControllerInitializationStrategy;
